<div class="web-view">



    <div class="main-div" fxLayout="row wrap">
        <div class="bodyClass">

            <div class="headers">
                <a href="userProfiles/{{userId}}/setup/2"> <img src="assets\images\orange image.png" class="backArrow"></a>

                <h1 class="heading1">Add to Your Treasury Collection</h1>
                <a href="/userProfiles/{{userId}}/setup/4" class="skip"><button (click)="skip()" class="skipbtn" style="padding:1% 5%;"
                     appTrackClick
                    [buttonProps]="{
                        title:'setup_three_skip_button',
                        feature_context:'ONBOARDING'
                    }"
                    >Skip</button></a>

            </div>
            <form [formGroup]="myForm">

            <p class="textClass">Treasures are creative works you love, including your own or those you've discovered.
                Add your favorite creations, such as books, movies, tech, art, and music,
                to your Treasury. Start by sharing your first Treasure now.
            </p>
            <div class="row">
                <div class="col-md-4">
                    <div class="row">


                        <div class="imgUpload" (change)="onFileChange($event)"
                            [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
                            (click)="image1.click();click()" accept="image/*" 
                             appTrackClick
                            [buttonProps]="{
                                title:'setup_three_picture_upload_button',
                                feature_context:'ONBOARDING'
                            }"
                            >

                            <div class="align-center">
                                <image-cropper *ngIf="stopCropper" [imageChangedEvent]="imgChangeEvt" [maintainAspectRatio]="true"
                                [aspectRatio]="4 / 4" [resizeToWidth]="256" format="png"
                                (imageCropped)="imageCropped($event,'image')" (imageLoaded)="imgLoad()"
                                (cropperReady)="initCropper()" (loadImageFailed)="imgFailed()">
                            </image-cropper>

                                <figure class="icons" input type="file" accept="image/*">

                                    <input class="form-control" type="file" [disabled]="imageFlag"
                                        (change)="onFileChange($event)" accept="image/*" #image1>
                                    <div class="items-center">
                                        <img src="assets\svg\photo icon.svg" style="margin-top:50%" *ngIf="iconDisabled" height="50">
                                    </div>
                                    <figcaption class="vdocaption" style="color:black;padding-bottom:50% ;" *ngIf="iconDisabled">Upload
                                        Picture
                                    </figcaption>


                                </figure>

                            </div>
                        </div>

                        <img class="imgClass" *ngIf="treasuryData && !treasuryData[0]?.treasuryImageUrl &&!stopCropper" [src]="cropImgPreview">
                        <img class="imgClass" *ngIf="treasuryData && treasuryData[0]?.treasuryImageUrl" [src]="cropImgPreview">

                    </div>
                    <button class="cropButton" *ngIf="cropButton"
                        [ngStyle]="(clickedCrop) ? {'visibility': 'hidden'} : {'visibility': 'visible'} "
                        (click)="cropImage('image1')">

                        CROP
                    </button>
                    <span aria-hidden="true" *ngIf="cropButton"
                        [ngStyle]="(clickedCrop) ? {'visibility': 'hidden'} : {'visibility': 'visible'} "
                        class="required"></span>
                </div>

                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-2">
                            <label for="title">Title:</label>
                        </div>
                        <div class="col-md-10">
                            <input class="title" placeholder=" Title for the Treasure up to 128 characters"maxlength="128"
                                type="text" id="title"
                                formControlName="title">
                        </div>
                    </div>

                    <div class="row">

                        <div class="col-md-2">

                            <label for="title">Category:</label>
                        </div>

                        <div class="col-md-10">

                            <select class="category" formControlName="category"  id="category">

                                <option disabled selected value >Select category </option>
                                <option value="Arts&design"  >Art & Design</option>
                                <option value="books">Books & Storytelling</option>
                                <option value="dance">Dance</option>
                                <option value="fashion">Fashion</option>
                                <option value="film">Film</option>
                                <option value="radio">Radio</option>
                                <option value="tech">Tech & Science</option>
                                <option value="television">Television</option>
                                <option value="virtual">Virtual Reality</option>
                                <option value="otherOpt" >Other Category</option>
                            </select><br>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label for="title">Description:</label><br>
                        </div>
                        <div class="col-md-10">
                            <textarea class="description"
                                placeholder=" Treasure description up to 500 characters. Minimum 6 characters"maxlength="500"
                                type="text" id="description" formControlName="description"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label for="title">Link:</label>
                        </div>
                        <div class="col-md-10">
                            <input class="title"
                                placeholder="Link for others to learn about the Treasure"
                                formControlName="url" type="url" id="title"
                                name="link">

                            <div *ngIf="m.url.touched && m.url.invalid" class="alert alert-danger">
                                <div *ngIf="m.url.errors?.required">Please provide URL</div>
                                <div *ngIf="m.url.errors?.pattern">Please provide valid URL</div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </form>
            <button class="submitbtn"
                [ngStyle]="(myForm.valid) ?   {'cursor' :'pointer','opacity':'1'}:{'cursor': 'not-allowed','opacity':'0.65'}"
                [disabled]="!myForm.valid"
                (click)="submit()"
                 appTrackClick
                [buttonProps]="{
                    title:'setup_three_submit_button',
                    feature_context:'ONBOARDING'
                }"
                >Submit</button>

        </div>
    </div>


</div>